import React from "react";


function Member() {
    return(
        <h1>Member </h1>
    )
}

export default Member;